import {classes} from '@bitstillery/common/lib/utils'
import {unique_id} from '@bitstillery/common/lib/utils'
import {MithrilComponent} from '@bitstillery/mithril'
import {Tippy} from '@bitstillery/common/components/ui/tip/tip'
import {modelref_adapter, modelref_assign} from '@bitstillery/common/lib/store'
import m from '@bitstillery/mithril'

import type {FieldCheckboxAttrs} from '@bitstillery/common/types/field'
import {failure_message} from '@bitstillery/common/lib/validation'

export class FieldCheckbox extends MithrilComponent<FieldCheckboxAttrs> {
    model_value: unknown
    name = unique_id()
    props: {off: boolean; on: boolean}

    constructor(vnode: m.Vnode<FieldCheckboxAttrs>) {
        super()
        this.props = vnode.attrs.props ? vnode.attrs.props : {off: false, on: true}
    }

    view(vnode: m.Vnode<FieldCheckboxAttrs>) {
        const {validation} = vnode.attrs
        const invalid = validation ? validation._invalid : false
        const {disabled} = vnode.attrs
        const has_children = Array.isArray(vnode.children) && vnode.children.length > 0
        // Computed property that overrides the reference.
        if (vnode.attrs.computed) {
            this.model_value = vnode.attrs.computed()
        } else if (vnode.attrs.model) {
            const {model_value, model_ref} = modelref_adapter(vnode.attrs.model)
            this.model_value = model_ref !== null ? model_value : undefined
        }

        const input_element = (
            <input
                checked={this.model_value === this.props.on}
                disabled={disabled}
                id={this.name}
                name={this.name}
                onclick={vnode.attrs.onclick}
                onchange={() => {
                    if (vnode.attrs.validation) {
                        vnode.attrs.validation.dirty = true
                    }
                    if (vnode.attrs.computed) {
                        this.model_value = vnode.attrs.computed()
                    } else if (vnode.attrs.model) {
                        const {model_ref} = modelref_adapter(vnode.attrs.model)
                        if (model_ref !== null) {
                            if (this.model_value === this.props.on) {
                                this.model_value = this.props.off
                            } else {
                                this.model_value = this.props.on
                            }
                            modelref_assign(model_ref, this.model_value)
                        }
                    }

                    if (vnode.attrs.onAfterChange) {
                        vnode.attrs.onAfterChange(this.model_value)
                    }
                }}
                type='checkbox'
            />
        )

        return (
            <div
                className={classes(
                    'c-checkbox',
                    'field',
                    vnode.attrs.className,
                    vnode.attrs.type ? `type-${vnode.attrs.type}` : 'type-default',
                )}
                key={vnode.attrs.key}
            >
                {vnode.attrs.tip ? (
                    <Tippy
                        content={typeof vnode.attrs.tip === 'function' ? vnode.attrs.tip() : vnode.attrs.tip}
                        placement='right'
                        delay={[500, 0]}
                        onclick={() => {}}
                    >
                        {input_element}
                    </Tippy>
                ) : (
                    input_element
                )}
                {(vnode.attrs.label || has_children) && (
                    <label for={this.name}>
                        {has_children && vnode.children}
                        {!has_children && vnode.attrs.label}
                        {validation && <span className='validation'>{validation.label}</span>}
                    </label>
                )}
                {(() => {
                    if (invalid && validation?.dirty) {
                        return <div className='help validation'>{failure_message(invalid)}</div>
                    } else if (vnode.attrs.help) {
                        return <div class='help'>{vnode.attrs.help}</div>
                    }
                    return undefined
                })()}
            </div>
        )
    }
}
